export default "__VITE_ASSET__Bsnm5pTP__"